import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { APP_SETTINGS } from "../../shared/models/backofficeConfiguration";
import { ErrorHandlerService } from "../../shared/services/errorHandler.service";
import { ExecuteService } from "../../shared/services/executeService.service";
import { SignalI3 } from "../models/SignalI3";

@Injectable()
export class SignalsI3Service {

    constructor(private executeService: ExecuteService,
        private errorHandler: ErrorHandlerService) {

    }

    public GetAll(locale: string): Observable<SignalI3[] | object> {
        const requestUrl = `${APP_SETTINGS.SignalsConfig.SignalsApiUrl}${locale}/api/v2/SignalsInternal`;
        return this.executeService.ExecuteWithApiToken('get', requestUrl)
            .pipe(
                map(signals => {
                    const signalsArray: SignalI3[] = [];
                    signals.forEach(element => {
                        signalsArray.push(new SignalI3({ ...element }));
                    });

                    return signalsArray;
                }),
                catchError(this.errorHandler.handleError<object>('SignalsI3Service_GetAll', null))
            )
    }
}


// WEBPACK FOOTER //
// ./src/app/tradingstudio/services/signalsI3.service.ts